import {
  createContext,
  useState,
  useContext,
  useCallback,
  useMemo,
} from 'react'
import { IReservationConsultationData } from '../types'
import { FunctionComponentChildren } from '@/@types/react'

interface IReservationConsultationContext {
  reservationConsultationData: IReservationConsultationData
  setReservationConsultationData: (reservationConsultationData) => void
}

const ReservationConsultationContext =
  createContext<IReservationConsultationContext>(null)

export const ReservationConsultationProvider: FunctionComponentChildren = ({
  children,
}) => {
  const [reservationConsultationState, setReservationConsultationState] =
    useState(null)

  const setReservationConsultationData = useCallback(
    (reservationConsultationData: IReservationConsultationData) => {
      setReservationConsultationState(reservationConsultationData)
    },
    [],
  )

  const values = useMemo(
    () => ({
      reservationConsultationData: reservationConsultationState,
      setReservationConsultationData,
    }),
    [reservationConsultationState, setReservationConsultationData],
  )

  return (
    <ReservationConsultationContext.Provider value={values}>
      {children}
    </ReservationConsultationContext.Provider>
  )
}
export const useReservationConsultationContext =
  (): IReservationConsultationContext => {
    const context = useContext(ReservationConsultationContext)
    if (!context) {
      throw new Error(
        'useReservationConsultationContext must be used within a GroupConsultationProvider',
      )
    }
    return context
  }
